module.exports = __webpack_public_path__ + "static/media/icon-person-idea-white.7a3e57d8.svg";